import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { CustomerUserActionConfigService } from '../../services/customer-user-action-config/customer-user-action-config.service';
import { User } from '../../state/auth/types';
import { AssortmentService } from '../../services/assortment.service';
import { CustomerDetailsConfigService } from '../../services/customer-details-config/customer-details-config.service';
import { first, forkJoin } from 'rxjs';

@Component({
    selector: 'lib-customer-user-card-list',
    templateUrl: './customer-user-card-list.component.html',
    styleUrls: ['./customer-user-card-list.component.css'],
    standalone: false
})
export class CustomerUserCardListComponent extends ListItemRendererComponent<User[]> implements OnInit, AfterViewInit {
  protected assortmentService = inject(AssortmentService);
  protected customerDetailsConfigService = inject(CustomerDetailsConfigService);

  showAssortmentInfo = this.customerDetailsConfigService.showAssortmentInfo;
  assortmentNamesById: { [assortmentId: string]: string } = {};

  constructor(public actionConfig: CustomerUserActionConfigService) {
    super();
  }

  ngOnInit() {
    this.actionConfig.deleteEvent.subscribe(username => {
      this.data.splice(
        this.data.findIndex(user => user.username === username),
        1
      );
    });

    this.actionConfig.updateEvent.subscribe(u => {
      this.data.splice(
        this.data.findIndex(user => user.username === u.username),
        1,
        u
      );
    });

    if (this.showAssortmentInfo) {
      this.resolveAssortmentNames();
    }
  }

  protected resolveAssortmentNames(): void {
    const assortmentIds = Array.from(new Set((this.data || []).map(user => user.assortment).filter(id => !!id)));
    if (assortmentIds.length === 0) {
      return;
    }
    forkJoin(
      assortmentIds.map(id => this.assortmentService.getAssortment(id).pipe(first()))
    ).subscribe(assortments => {
      assortments.forEach((assortment, index) => {
        this.assortmentNamesById[assortmentIds[index]] = assortment?.name;
      });
    });
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }
}
